import { SettingsIcon } from "../../../assets/icons";
import { Button } from "@altimateai/lego";
import { createPortal } from "react-dom";
import { SETTINGS_SIDEBAR } from "../constants";
import { useLineageDispatch } from "../context/LineageProvider";
import { setSidebarScreen } from "../context/LineageSlice";

const SettingsButton = () => {
  const settingsContainer = document.getElementById("settings-container");
  const lineageDispatch = useLineageDispatch();
  if (!settingsContainer) {
    return null;
  }
  return createPortal(
    <Button
      variant="default"
      size="xs"
      onClick={() => lineageDispatch(setSidebarScreen(SETTINGS_SIDEBAR))}
    >
      <SettingsIcon />
      Settings
    </Button>,
    settingsContainer
  );
};

export default SettingsButton;
